document.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.luxury-search__input');
  const inputWrapper = document.querySelector('.luxury-search__input-wrapper');
  
  if (!searchInput || !inputWrapper) return;

  // Build Trending UI Block
  const trendingBlock = document.createElement('div');
  trendingBlock.className = 'luxury-trending';
  trendingBlock.innerHTML = `
    <div class="luxury-trending__grid">
      <div class="luxury-trending__column">
        <h3 class="luxury-predictive__heading">Trending Searches</h3>
        <div class="luxury-trending__tags">
          <a href="/search?q=linen+dress" class="luxury-trending__tag">Linen Dress</a>
          <a href="/search?q=bespoke+blazer" class="luxury-trending__tag">Bespoke Blazer</a>
          <a href="/search?q=evening+wear" class="luxury-trending__tag">Evening Wear</a>
          <a href="/search?q=silk" class="luxury-trending__tag">Silk</a>
        </div>
      </div>
      <div class="luxury-trending__column" id="recent-searches-container">
        <h3 class="luxury-predictive__heading">Recent Searches</h3>
        <ul class="luxury-predictive__list" id="recent-searches-list">
          <!-- Populated by JS -->
        </ul>
      </div>
    </div>
  `;
  inputWrapper.appendChild(trendingBlock);

  const recentList = document.getElementById('recent-searches-list');
  const recentContainer = document.getElementById('recent-searches-container');

  // Function to render recent searches from localStorage
  function renderRecent() {
    if (!recentList) return;
    try {
      const history = JSON.parse(localStorage.getItem('luxury_search_history') || '[]');
      if (history.length === 0) {
        recentContainer.style.display = 'none';
        return;
      }
      recentContainer.style.display = 'block';
      recentList.innerHTML = history.slice(0, 5).map(term => `
        <li>
          <a href="/search?q=${encodeURIComponent(term)}" class="luxury-predictive__link">
            <span class="svg-wrapper">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            </span>
            <span>${term}</span>
          </a>
        </li>
      `).join('');
    } catch (e) {
      console.error('Error loading search history', e);
    }
  }

  renderRecent();

  // Show/Hide Logic
  searchInput.addEventListener('focus', () => {
    if (searchInput.value.trim() === '') {
      trendingBlock.classList.add('is-active');
    }
  });

  searchInput.addEventListener('input', () => {
    if (searchInput.value.trim() !== '') {
      trendingBlock.classList.remove('is-active');
    } else {
      trendingBlock.classList.add('is-active');
    }
  });

  // Hide when clicking outside
  document.addEventListener('click', (e) => {
    if (!inputWrapper.contains(e.target)) {
      trendingBlock.classList.remove('is-active');
    }
  });

  // Save search query on form submit
  const form = searchInput.closest('form');
  if (form) {
    form.addEventListener('submit', () => {
      const val = searchInput.value.trim();
      if (val) {
        try {
          let history = JSON.parse(localStorage.getItem('luxury_search_history') || '[]');
          // Remove duplicates
          history = history.filter(h => h.toLowerCase() !== val.toLowerCase());
          // Add to beginning
          history.unshift(val);
          // Save back
          localStorage.setItem('luxury_search_history', JSON.stringify(history));
        } catch(e) {}
      }
    });
  }
});
